import React, { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { AlertTriangleIcon, InfoIcon, Loader2Icon, LockIcon } from 'lucide-react';
import { Logo } from '../components/Logo';
import { useAuth } from '../contexts/AuthContext';
import { buttonClass, fieldClass } from '../utils/styles';
export function Login() {
  const {
    session,
    login
  } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as {
    from?: string;
  } | null)?.from ?? '/admin';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  if (session) return <Navigate to={from} replace data-id="element-417" data-mp="2yl8rk7zllymr" />;
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!email.trim() || !password) {
      setError('Introduce tu correo y tu contraseña.');
      return;
    }
    setLoading(true);
    try {
      await login(email, password);
      navigate(from, {
        replace: true
      });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudo iniciar sesión.');
    } finally {
      setLoading(false);
    }
  };
  return <div className="flex min-h-[calc(100svh-4rem)] items-center justify-center px-5 pb-16 pt-28" data-id="element-418" data-mp="2wgf5og7x7ap3">
      <div className="w-full max-w-sm" data-id="element-419" data-mp="3a7a5z44csjh2">
        <div className="flex flex-col items-center text-center" data-id="element-420" data-mp="3a68tcv7ovox8">
          <Logo variant="mark" className="h-12 w-12 text-2xl" data-id="element-421" data-mp="358pdjqvcf436" />
          <h1 className="mt-6 font-display text-2xl font-bold" data-id="element-422" data-mp="35ajpifomzlv4">Acceso privado</h1>
          <p className="mt-2 text-sm text-mist" data-id="element-423" data-mp="3k57uztu1ekaq">Panel de administración de NICOLE.</p>
        </div>

        <form onSubmit={handleSubmit} noValidate className="mt-8 space-y-5 rounded-xl border border-graphite bg-coal p-6" data-id="element-424" data-mp="3f76dveg68v1w">
          {error && <div role="alert" className="flex items-start gap-2.5 rounded-md border border-alert/40 bg-alert/10 px-3.5 py-3 text-sm text-white" data-id="element-425" data-mp="1ksvlwx4a5krw">
              <AlertTriangleIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-alert" data-id="element-426" data-mp="2aic5zwnoucxu" />
              {error}
            </div>}
          <div data-id="element-427" data-mp="2jhpf2o7wgzi1">
            <label htmlFor="login-email" className="block text-sm font-medium" data-id="element-428" data-mp="2jh67o1fvlti9">Correo electrónico</label>
            <input id="login-email" type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} className={`${fieldClass(false)} mt-2`} data-id="element-429" data-mp="2ohk6qtzi1t45" />
          </div>
          <div data-id="element-430" data-mp="327f9ha7r3j9f">
            <label htmlFor="login-password" className="block text-sm font-medium" data-id="element-431" data-mp="327nphaz674ou">Contraseña</label>
            <input id="login-password" type="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} className={`${fieldClass(false)} mt-2`} data-id="element-432" data-mp="375ywldy2z13d" />
          </div>
          <button type="submit" disabled={loading} className={buttonClass('primary', 'md', 'w-full')} data-id="element-433" data-mp="15ivzluqymyix">
            {loading ? <Loader2Icon className="h-4 w-4 animate-spin" data-id="element-434" data-mp="10h6nscvwygts" /> : <LockIcon className="h-4 w-4" data-id="element-435" data-mp="vjexfnax32rp" />}
            {loading ? 'Comprobando…' : 'Entrar'}
          </button>
        </form>

        <p className="mt-5 flex items-start gap-2 text-xs leading-relaxed text-mist" data-id="element-436" data-mp="qln6avi3jkok">
          <InfoIcon aria-hidden="true" className="mt-0.5 h-3.5 w-3.5 shrink-0" data-id="element-437" data-mp="1o8vp2iqpqfmv" />
          Modo demostración: acepta cualquier correo válido y una contraseña de 8 caracteres o más. Conecta un proveedor de autenticación antes de publicar.
        </p>
      </div>
    </div>;
}